import { render } from "./DeliveriesnewForm.vue?vue&type=template&id=df3af3b4&scoped=true"
import script from "./DeliveriesnewForm.vue?vue&type=script&lang=js"
export * from "./DeliveriesnewForm.vue?vue&type=script&lang=js"

import "./DeliveriesnewForm.vue?vue&type=style&index=0&id=df3af3b4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Isaias\\Documents\\Vue\\EntregasApp\\Lupnova\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df3af3b4"]])

export default __exports__